export default __webpack_public_path__ + "static/html5-87f36abe22407e603237b69718cc32c1.png";